var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mx-page',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isChild),expression:"!isChild"}],key:_vm.timespan,attrs:{"type":"Home","config":_vm.master,"parent":_vm.parent,"is-child":_vm.isChild,"name":_vm.Name}}),(_vm.isChild)?_c('router-view',{staticClass:"router-view",attrs:{"slot":"child"},slot:"child"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }